<script setup>
import footerContainer from "@/components/common/footer/footerContainer.vue";
import navbar from "@/components/common/navbar/navbar.vue";
// import autoAuth from "@/utils/autoAuth.js";
import swiper from "@/components/swiper/Swiper.vue";
import recharge from "@/components/common/recharge/index.vue";
// import {useStore} from '@/store/module/test.js';
import $store from "@/store";
import $api from "@/api";
import eventEmitter from "@/utils/emitter.js";
import {loginModal} from "@/components/common/login";
import {signupModal} from "@/components/common/qiesignup";
import {emailSignUpModal} from "@/components/common/emailLogin";
import rechargeModal from "@/components/common/recharge";
import playInfo from "@/components/common/playInfo/index.vue";
import sitemaintenance from "@/components/common/sitemaintenance/index.vue";
import isBalanceEnough from "@/utils/isBalanceEnough.js";
import telegramAuth from "@/components/common/telegramAuth/telegramAuth.vue";
import rechargeRebate from "@/components/common/rechargeRebate/index.vue";
import rechargeRebateSmall from "@/components/common/rechargeRebate/small.vue";
import globalModal from "@/components/common/globalModal/index.vue";
import {showRechargeRebateModal} from "@/utils/auth.js";
import ga4 from "@/utils/ga4.js";
// import swiperg from "@/components/common/swiper/swiperg.vue";
import {
  toRefs,
  ref,
  getCurrentInstance,
  onMounted,
  onBeforeUnmount,
  onUnmounted,
  computed,
  nextTick,
  provide,
} from "vue";
import {useRoute, useRouter} from "vue-router";
import {getImageUrlByNewURL} from "@/utils/getImageUrl.js";

import i18n, {i18nReady} from "@/i18n";
import user from "./api/user";
import handleResponse from "@/utils/handleResponseData.js";
import showNotice from "@/components/common/notice/notice.js";
import {useCookies} from "vue3-cookies";
import { useFbPixel, StandardEvents } from '@/utils/useFbPixel.js'
const { trackEvent } = useFbPixel({
  pixelId: import.meta.env.VITE_META_PIXEL_ID
})
const deviceStore = $store("deviceInfo")();

const {cookies} = useCookies();
const {t: $t, locale} = i18n.global;
// import { useFbq } from "vue3-facebook-pixel";
// const fbq = useFbq();
const route = useRoute();
const router = useRouter();
const userstore = $store("user");
// console.log('ustore;',userstore);
const cacheComponents = computed(() => {
  const cacheRoutes = ["rolldetail", "daily"];
  return cacheRoutes.includes(route.name) ? ["GiftCase"] : [];
});

// import sp from '@/utils/sp.js'
// console.log('sp;',sp.value);
//站点公共信息
// $api.user.getInfo().then((res) => {
//   // console.log("站点公共信息", res);
//   // $store("user").SitePublicDataFn(res);
// });

/**
 * 测试获取用户信息,未登录显示登录弹框  //$del test待删
 */
function test() {
  $store("user")
      .getUserInfo()
      .then((res) => {
        console.log("res;", res);
      });
}

const {proxy} = getCurrentInstance();
const fightStore = $store("arena");
const siteStore = $store("siteInfo");
// console.log("站点公共信息", siteStore.isConnect);
// console.log("fightstore;", fightStore);

/**
 * 加入盒子竞技频道
 * @param {*} client_id websocket 频道id 全局加入一次 网站打开就加入
 */
function PostBlind_box_channel(id) {
  console.log("join box channel webSocket_id;", id);
  $api.battle.joinChannel({client_id: id}).then((res) => {
    console.log("加入频道;", res);
  });
}

//加入房间
function JoinGroup(data) {
  console.warn("加入房间;", data);
  if (data.user_id == userstore.userInfo.id) {
    if (Number(data.is_gem) === 1) {
      proxy.$EventBus.emit("upd", {
        type: "decrement",
        gem: true,
        val: data.bean,
      });
    } else {
      proxy.$EventBus.emit("upd", {
        type: "decrement",
        val: data.bean,
      });
    }
  }
  //把websocket推送的加入房间信息传给arenaStore,在对战详情页面通过监听arenaStore.AddInformation变化,做出加入对战的进一步逻辑处理
  fightStore.AddInformationFn(data);
}

//创建房间
function Accept(data) {
  console.warn("全局App,vue监听到===>创建accept", data);

  if (data.create_user_id == userstore.userInfo.id) {
    //获取game_short_player数组内当前用户
    const tempuser = data.game_short_player.find((item) => item.user_id === userstore.userInfo.id)
    if (Number(tempuser.is_gem) === 1) {
      //更新宝石余额
      proxy.$EventBus.emit("upd", {
        type: "decrement",
        gem: true,//表示用宝石开箱,更新宝石扣费动效
        val: data.total_bean,
      });
    } else {
      //更新账户余额
      proxy.$EventBus.emit("upd", {type: "decrement", val: data.total_bean});
    }
  }
  fightStore.createArena(data);
}

//退出房间(取消准备,准备,允许机器人加入 退出房间)
function OperateGroup(data) {
  // console.warn("对战操作", data);
  fightStore.AddInformationFn(data);
}

//获取对战详情数据
function GetArenaData(data) {
  // console.warn("获取对战详情数据", data);
  fightStore.getArenaDetail(data);
}

//对战开始
function AddStartGroup(data) {
  // console.warn("对战开始", data);
  // fightStore.GetKaiShiVsData(data);
  fightStore.GetJieShuVsData(data);
}

//ping
function Ping(data) {
  // console.warn('socket ping;',data);
  fightStore.pingInfoMationFn(data);
}

//对战结束
function AddEndGroup(data) {
  // console.warn("对战结束;", data);
  // fightStore.GetJieShuVsData(data);
  fightStore.endGame(data);
}

//adjust上报事件
function AdjustWeb(data) {
  if(window.location.hostname.includes("fateskins.net")){
    return;
  }
  // Adjust 已停用：不再调用 SDK，仅回执给后端（避免后端重复推送）
  console.log("adjust上报事件：", data);
  if (data.user_id == userstore.userInfo.id) {
    var updata = {
      MsgType: 'ajust',
      msg_id: data.id,
    };
    proxy.$socket.Send(updata);
  }
}
//MetaPixel上报事件
function MetaPixel(data) {
  if(window.location.hostname.includes("fateskins.net")){
    return;
  }
  console.log("MetaPixel上报事件：", data);
  if (data.user_id == userstore.userInfo.id) {
    if(data && data.token === "COMPLETE_REGISTRATION"){
      trackEvent(StandardEvents.COMPLETE_REGISTRATION, {
        value: 0.00,
        currency: 'USD'
      })
    }
    if(data && data.token === "ADD_TO_CART" && data.hasOwnProperty('money')){
      let content_ids = 'skinroll_' + data.name;
      let money = data.money;
      trackEvent(StandardEvents.ADD_TO_CART, {
        content_ids: [content_ids],
        content_type: 'product',
        value: money,
        currency: 'USD'
      })
    }
    if(data && data.token === "PURCHASE" && data.hasOwnProperty('money')){
      let content_ids = 'skinroll_' + data.name;
      let money = data.money;
      trackEvent(StandardEvents.PURCHASE, {
        content_ids: [content_ids],
        content_type: 'product',
        value: money,
        currency: 'USD'
      })
    }
    var updata = {
      MsgType: 'ajust',
      msg_id: data.id,
    };
    proxy.$socket.Send(updata);
  }
}
//关站维护
const ismaintenance = ref(false); //是否关站
const mainData = ref({}); //关站公告提示内容
const falg = ref(false)

//站点公共数据
function SitePublicData(data) {
  //start test code
  // if (!falg.value) {
  //   falg.value = true
  //   PayAtm({
  //     atm_id: 4,
  //     bean: 100,
  //     out_trade_no: 213782139827,
  //     user_id: 604227
  //   })
  // }
  //end test code


  // console.warn("站点公共数据", data);
  if (data.site_switch == 0) {
    console.error("关站维护");
    ismaintenance.value = true;
    mainData.value = data;
    return;
  }
  if (parseFloat(data.user_rebate_switch) === 1) {
    console.log("开启充值返利弹框-侧边栏");
    siteStore.rechargeRebateSmallVisible = true;
    cookies.get("closeRebate") ? siteStore.closeRebate = true : siteStore.closeRebate = false;
    console.log("cookies:", cookies.get("closeRebate"));
  } else {
    console.log("关闭充值返利弹框-侧边栏");
    siteStore.rechargeRebateSmallVisible = false;
  }
  siteStore.updateSiteInfo(data);
}

//获取首页箱子数据
function SitePublicBoxData(data) {
  // console.warn("获取首页箱子数据", data);
  siteStore.updateSiteBoxData(data);
}

//websocket 开箱推送的箱子 存放到轮播箱子列表
function OpenBoxRecord(data) {
  // console.warn("开箱推送的箱子 存放到轮播箱子列表", data);
  siteStore.updateHotcase(data);
}

//skins皮肤充值后弹冻结皮肤弹框
function PayAtm(data) {
  // user_id: 用户id
  // out_trade_no: 订单号
  // bean://金额
  //     atm_id://存钱罐记录id
  console.log("PayAtm:", data);
  if (data.user_id === userstore.userInfo.id) {
    //皮肤充值到账,不弹冻结皮肤弹框,更新宝石余额
    proxy.$EventBus.emit("upd", {
      type: "increment",
      gem: true,
      val: data.bean,
    });

    //以下是之前皮肤充值到账后弹冻结皮肤弹框,现不用
    // const params = {
    //   bean: data?.bean,//金额
    //   atm_id: data?.atm_id,//存钱罐记录id
    // }
    // globalModalData.value = params
    // eventEmitter.emit("api:freezeSkin", params);
    // proxy.$EventBus.emit("upd", {type: "skinsPay", bank: true, bankType: "increment", val: data.bean});

  }
}

//websocket 推送的订单到账数据
function PayNoify(data) {
  // console.warn("websocket 推送的订单到账数据", data);
  if (userstore.userInfo.id == data.user_id) {
    // console.error("t当前到账;", data);
    //data返回以下内容
    // const mockdata = {
    //   user_id: 2047,
    //   out_trade_no: "202502260254071546",
    //   bean: "500.00",
    // };
    proxy.$notice("s", {
      desc: $t("payStatusInfo", {account: "$" + data.bean}),
    });
    // if (data.fb_event === "PURCHASE") {
    //   fbq.event("Purchase", {
    //     currency: "USD",
    //     value: data.bean,
    //   });
    // }
    //更新账户余额
    proxy.$EventBus.emit("upd", {
      type: "increment",
      val: data.bean,
      paytype: "pay",
    });
    //更新状态,提示用户,关闭订单监听
    // stopOrderListening();
  }
}

//$del
//websocket 推送的订单状态数据
function BeanDetail(data) {
  console.warn("websocket 推送的订单状态", data);
  if (data.status != 1) {
    console.log("订单状态不为1,继续监听直到状态变为1,关闭定时器监听");
  } else {
    proxy.$notice("s", {
      desc: $t("payStatusInfo", {account: "$" + data.bean}),
    });

    //更新账户余额
    proxy.$EventBus.emit("upd", {
      type: "increment",
      val: data.bean,
      paytype: "pay",
    });
    //更新状态,提示用户,关闭订单监听
    stopOrderListening();
  }
}

// 20分钟后读取请求一次用户余额值

function closeWebSocket() {
  console.log("网络断开", navigator.onLine);
  // proxy.$socket.Close();
  // proxy.$socket.Start();
}

function toUrl(data) {
  console.log("url;", data);
  if (data) {
    router.push("/" + route.params.lang + data.url);
  }
}

//关闭websocket
const handleFn = () => {
  // console.log("切换浏览器标签页");
  // proxy.$socket.Close();
};

function reload() {
  // console.log("切换标签 执行 reload");
}

// proxy.$socket
//   .Event((e) => {
//     console.log("加入对战频道socket Event", e);
//     sessionStorage.setItem("C_id", e);
//     PostBlind_box_channel(e);
//   })
//   .Start();

proxy.$socket.Start();

/**
 * 发送z 获取服务器时间
 */
function getServerTime() {
  proxy.$socket.Send("z");
}

function initListenSocket() {
  // console.log("切换显示当前 csgo标签页");
  // proxy.$socket.Start();
  // reload();
  // //添加监听 websocket实时监听对战加入事件  若有加入则执行加入房间函数JoinGroup
  proxy.$socket.Add("joinGroup", JoinGroup);
  proxy.$socket.Add("OperateGroup", OperateGroup);
  // //通过websocket实时监听对战结束事件  若对战结束则执行对战结束函数AddEndGroup
  proxy.$socket.Add("endGroup", AddEndGroup);
  proxy.$socket.Add("startGroup", AddStartGroup);
  proxy.$socket.Add("CreateGroup", Accept);
  //监听推送的对战详情数据
  proxy.$socket.Add("arena_detail", GetArenaData);
  //监听websocket 站点公共数据 SitePublicData
  proxy.$socket.Add("info", SitePublicData);
  //监听websocket推送的首页箱子数据
  proxy.$socket.Add("PublicAll", SitePublicBoxData);
  //监听开箱 推送的热门箱子 添加到顶部轮播箱子列表
  proxy.$socket.Add("OpenBoxRecord", OpenBoxRecord);
  proxy.$socket.Add("ping", Ping);
  //监听推送的充值到账余额(监听虚拟货币充值到账)
  proxy.$socket.Add("PayNoify", PayNoify);
  //选择皮肤冻结弹框
  proxy.$socket.Add("PayAtm", PayAtm);
  //处理Ajust上报数据
  proxy.$socket.Add("adjust_web", AdjustWeb);
  //处理FB上报数据
  proxy.$socket.Add("Meta_Pixel", MetaPixel);

  console.log("初始网络状态;", navigator.onLine);
  window.addEventListener("online", updateCount); // 监听网络恢复事件
  window.addEventListener("offline", closeWebSocket); // 监听网络恢复事件

  //监听websocket推送的订单状态
  // proxy.$socket.Add("bean_detail", BeanDetail);

  document.addEventListener("visibilitychange", (e) => {
    //隐藏标签
    if (document.visibilityState === "hidden") {
      handleFn();
    }
    //切换显示标签
    if (document.visibilityState === "visible") {
      // console.log("切换显示当前 csgo标签页");
      // proxy.$socket.Start();
      reload();
      //添加监听 websocket实时监听对战加入事件  若有加入则执行加入房间函数JoinGroup
      proxy.$socket.Add("joinGroup", JoinGroup);
      proxy.$socket.Add("OperateGroup", OperateGroup);
      //通过websocket实时监听对战结束事件  若对战结束则执行对战结束函数AddEndGroup
      proxy.$socket.Add("endGroup", AddEndGroup);
      proxy.$socket.Add("startGroup", AddStartGroup);
      proxy.$socket.Add("CreateGroup", Accept);
      //监听推送的对战详情数据
      proxy.$socket.Add("arena_detail", GetArenaData);
      //监听websocket 站点公共数据 SitePublicData
      proxy.$socket.Add("info", SitePublicData);
      //监听websocket推送的首页箱子数据
      proxy.$socket.Add("PublicAll", SitePublicBoxData);
      //监听开箱 推送的热门箱子 添加到顶部轮播箱子列表
      proxy.$socket.Add("OpenBoxRecord", OpenBoxRecord);
      proxy.$socket.Add("ping", Ping);
      //监听推送的充值到账余额
      proxy.$socket.Add("PayNoify", PayNoify);
      //选择皮肤冻结弹框
      proxy.$socket.Add("PayAtm", PayAtm);
      //处理Ajust上报数据
      proxy.$socket.Add("adjust_web", AdjustWeb);
      //处理FB上报数据
      proxy.$socket.Add("Meta_Pixel", MetaPixel);
      console.log("初始网络状态;", navigator.onLine);
      window.addEventListener("online", updateCount); // 监听网络恢复事件
      window.addEventListener("offline", closeWebSocket); // 监听网络恢复事件
      //监听websocket推送的订单状态
      // proxy.$socket.Add("bean_detail", BeanDetail);
    }
  });
  //浏览器关闭,浏览器标签页关闭,浏览器刷新均会触发 beforeunload 事件
  window.addEventListener("beforeunload", (e) => handleFn());
}

function emailVerifyLoginSignUp() {
  console.log("弹邮箱注册登录弹框");
  emailSignUpModal(
      {visible: true, title: $t("loginLarge"), contentType: "def"},
      (callnack) => {
        // console.log('未登录 弹登录框');
        callnack();
      }
  );
}

function telegramLogin() {
  console.log("显示飞机登录弹框");
  telegramLoginVisible.value = true;
  nextTick(() => {
    showTeleVisible.value = true;
  });
}

function qieSignUp() {
  console.log("有邀请码,弹小企鹅框");
  //未登录显示登录框
  signupModal(
      {visible: true, title: $t("loginLarge"), contentType: "def"},
      (callnack) => {
        // console.log('未登录 弹登录框');
        callnack();
      }
  );
}

function freeruSignUp() {
  console.log("有邀请码,弹freeru框");
  //未登录显示登录框
  signupModal(
      {visible: true, title: $t("loginLarge"), inviteType: "FREERU", contentType: "def"},
      (callnack) => {
        // console.log('未登录 弹登录框');
        callnack();
      }
  );
}

// 全量获取URL参数并处理
const getUrlParams = () => {
  const search = window.location.search.substring(1); // 去除开头的"?"
  const params = new URLSearchParams(search);
  const allParams = Object.fromEntries(params.entries()); // 转为对象
  // console.log('search:', search,'params:',params, 'allParams:', allParams);
  // 存储指定参数
  // if (allParams.invite_id) {
  //   localStorage.setItem('invite_id', allParams.invite_id);
  //   console.log('参数已存储:', allParams.invite_id);
  // } else {
  //   console.warn('未找到invite_id参数');
  // }
  return allParams;
};

onMounted(() => {
  // steam回调认证由steamcallback地址改为首页或任何一个路由地址
  // 获取当前 URL
  const currentUrl = window.location.href;

  console.log("当前 URL:", currentUrl);
  // 创建 URL 对象
  const url = new URL(currentUrl);
  console.log("当前 new URL:", currentUrl);
  // 使用 URLSearchParams 获取查询参数
  const params = new URLSearchParams(url.search);
  console.log("params:", params);
  //  URLSearchParams {size: 10}

  // 将参数转为一个对象
  const queryParams = {};
  params.forEach((value, key) => {
    queryParams[key] = decodeURIComponent(value); // 使用 decodeURIComponent 解码
  });
  console.log("params:", params);
  console.log("params.size:", params.size);
  console.log("params:field:", params["openid.claimed_id"]);
  console.log("queryParams:", queryParams);
  console.log("queryParams:", queryParams["openid.claimed_id"]);

  const uid = queryParams["uid"];
  const auth_token = queryParams["token"];
  const event = queryParams["event"];
  const verifyCode = queryParams["code"];
  const status = queryParams["status"];
  const bankpay = queryParams["bankpay"];
  if ("discord" === event) {
    i18nReady.then(() => {
    if (status === "success") {
      if (verifyCode && verifyCode !== "0") {
        // 新安全方案：一次性验证码（服务端 server-to-server 验证）
        console.log("discord code:", verifyCode);
        $api.user
            .discordHandle({params: {code: verifyCode}})
            .then((res) => {
              console.log("discordHandle:", res);
              if (res && res.code === 200) {
                // 检查是否是绑定场景（无 access_token）
                if (!res.data || !res.data.access_token) {
                  console.log("discord 绑定成功");
                  showNotice("s", {desc: $t("discordBindSuccess")});
                  router.push("/");
                  return;
                }
                // 登录场景
                const resp = handleResponse(res);
                if (!resp) return console.log("未知错误", res.message);
                LoginSuccessUpdate(resp);
              } else {
                console.log("discord 处理失败", res.message);
                showNotice("f", {desc: res.message || "未知错误"});
                router.push("/");
              }
            });
      } else {
        console.log("discord 绑定成功");
        showNotice("s", {desc: $t("discordBindSuccess")});
        router.push("/");
      }
    } else if (status === "used") {
      console.log("discord 已被绑定");
      showNotice("f", {desc: $t("discordBound")});
      router.push("/");
    } else {
      console.log("discord 绑定失败");
      showNotice("f", {desc: $t("discordBindFailed")});
      router.push("/");
    }
    });
  }
  if ("telegram" === event) {
    i18nReady.then(() => {
    if (status === "success") {
      if (verifyCode && verifyCode !== "0") {
        // 新安全方案：一次性验证码（服务端 server-to-server 验证）
        console.log("telegram code:", verifyCode);
        $api.user
            .telegramHandle({params: {code: verifyCode}})
            .then((res) => {
              console.log("telegramHandle:", res);
              const resp = handleResponse(res);
              if (!resp) return console.log("未知错误", res.message);
              LoginSuccessUpdate(resp);
            });
      } else if (uid && auth_token) {
        // 兼容旧方案
        console.log("uid:", uid, "auth_token:", auth_token, "event:", event);
        $api.user
            .telegramHandle({params: {uid: uid, auth_token: auth_token}})
            .then((res) => {
              console.log("telegramHandle:", res);
              const resp = handleResponse(res);
              if (!resp) return console.log("未知错误", res.message);
              LoginSuccessUpdate(resp);
            });
      } else {
        console.log("telegram 绑定成功");
        showNotice("s", {desc: $t("TelegramBindSuccess")});
        router.push("/");
      }
    } else if (status === "used") {
      console.log("telegram已被绑定");
      showNotice("f", {desc: $t("TelegramBound")});
      router.push("/");
    } else {
      console.log("telegram 绑定失败");
      showNotice("f", {desc: $t("TelegramBindFailed")});
      router.push("/");
    }
    });
  }
  console.log('bank success');

  if ('success' === bankpay) {
    const lang = localStorage.getItem('lang') || 'unn';
    router.push(`/${lang}/bank`)

  } else if ('fail' === bankpay) {
    console.log('bank fail');
    router.push("/")
  }


  //bug discord / telegram 账号已绑定处理

  //登录注册成功后更新站点数据
  function LoginSuccessUpdate(res) {
    // if (res.fb_event === "CompleteRegistration") {
    //   fbq.event("CompleteRegistration");
    // }
    localStorage.setItem("token", res.access_token);
    showNotice("s", {desc: $t("loginSuccess")});

    //登录成功更新用户数据
    const token = localStorage.getItem("token");
    if (token) {
      userstore.$patch((state) => {
        state.isToken = true;
        //tag  更新组件key  强制重新渲染组件 显示loading?
      });
      userstore.getUserInfo().then((res) => {
        console.log("登录成功,更新用户数据;", res);
        console.log("router;", userstore.from);
        const frompath = localStorage.getItem("currentPath");
        console.log("frompath;", frompath);
        // emits("close");
        showRechargeRebateModal(userstore, $api, handleResponse);
        //返回登录前的路由或首页
        if (userstore.sandbox) {
          router.push(frompath || "/sandbox");
        } else {
          router.push(frompath || "/");
        }

        //回到首页,清除地址栏参数
        // router.push("/");
      });
    }
    //更新数据后关闭登录弹框
  }

  console.log("请求参数", queryParams);
  //地址栏有请求参数,并且请求参数是steam回调认证内的字段   steam认证登录,拿到token
  if (queryParams["openid.claimed_id"]) {
    $api.user.handleSteam({params: queryParams}).then((res) => {
      console.log("steamcallback回调请求", res);
      console.log("steam认证登录");
      const resp = handleResponse(res);
      if (!resp) {
        router.push("/");
        return console.log("未知错误", res.message);
      }
      LoginSuccessUpdate(resp);
    });
  }

  console.log("小企鹅");
  // 初始化执行
  const urlParams = getUrlParams();
  console.log("urlParams:", urlParams);
  //有invite_id参数,则弹出小企鹅sign up 框
  //已登录不弹邀请码登录弹框 未登录有邀请码则弹对应邀请码的登录弹框
  if (!userstore.isToken) {
    if (urlParams.hasOwnProperty("invite_id")) {
      localStorage.setItem("invite_id", urlParams.invite_id);
      // 2026-10-14 主播弹窗配置化：改为向后端取配置，有配置才弹窗（不依赖硬编码名单）
      // 老 4 码（cs2kinguin/FB0001/fb0000/freeru）已写入 anchor_popups 表，走同一路径
      const legacyCodes = ["cs2kinguin", "FB0001", "fb0000", "freeru"];
      const fallbackLegacy = () => {
        if (legacyCodes.indexOf(urlParams.invite_id) === -1) {
          console.warn("[anchor] 该邀请码未配置弹窗或接口未返回数据:", urlParams.invite_id);
          return;
        }
        const ev = urlParams.invite_id === "freeru" ? "api:freeruSignUp" : "api:qieSignUp";
        setTimeout(() => eventEmitter.emit(ev), 1000);
      };
      $api.anchor.popup({ invite_id: urlParams.invite_id }).then((res) => {
        // 兼容 $api 可能返回的多种层级：{code,msg,data} / {data:{...}} / 直接就是 payload
        const candidates = [res, res && res.data, res && res.data && res.data.data];
        const d = candidates.find((c) => c && typeof c === "object" && c.invite_code) || null;
        console.log("[anchor] popup 响应:", res, "解析结果:", d);
        if (d && d.invite_code) {
          setTimeout(() => {
            signupModal(
              {
                visible: true,
                title: $t("loginLarge"),
                inviteType: "ANCHOR",
                contentType: "def",
                anchorTitle: d.title,

                anchorLine1: d.line1,

                anchorLine2: d.line2,

                bonusAmount: d.bonus_amount,
                promoCode: d.invite_code,
                depositPercent: d.deposit_percent,
                promoImage: d.promo_image || "",
                badgeImage: d.badge_image || "",
              },
              (callnack) => { callnack(); }
            );
          }, 1000);
        } else {
          fallbackLegacy();
        }
      }).catch((e) => {
        console.warn("[anchor] popup 接口失败:", e);
        fallbackLegacy();
      });
    }

    //截取地址栏?后数组下标为1的参数
    // const urlInvite = window.location.href.split("?")[1];
    // if (urlInvite) {
    //   const invite = urlInvite.split("=")[1];
    //   console.log("invite:", invite);
    // }
  }
});

function initCusEvent() {
  // 新增：监听完善邮箱弹框事件
  eventEmitter.on('api:showEmailReward', showEmailReward)
  // 2026-09-24: 交易链接失效提醒（文案由后端按用户语言下发）
  eventEmitter.on('api:steamUrlExpired', (payload) => {
    sessionStorage.setItem('steamUrlExpiredDismissed', '1')
    showNotice('w', { desc: (payload && payload.desc) ? payload.desc : '' })
  })
  //监听 订阅的登录弹框事件
  eventEmitter.on("api:update", updateCount);
  eventEmitter.on("api:un_auth", showLogin);
  eventEmitter.on("api:qieSignUp", qieSignUp);
  eventEmitter.on("api:emailVerifyLogin", emailVerifyLoginSignUp);
  eventEmitter.on("api:telegramLogin", telegramLogin);
  eventEmitter.on("api:freeruSignUp", freeruSignUp);
  eventEmitter.on("api:redirect", () => {
    console.log("重定向reload");
    if (userstore.sandbox) {
      router.push("/sandbox");
    } else {
      router.push("/");
    }
    userstore.count++;
  });

  //监听 订阅的充值弹框事件
  eventEmitter.on("api:no_enough", showRecharge);
  //监听运作方式事件
  eventEmitter.on("api:play_info", showPlayInfo);

  //监听余额是否足够游戏
  eventEmitter.on("api:is_enough", handleIsEnough);

  eventEmitter.on("api:pay_status", (data) => {
    const {pay} = data;
    console.log("app 充值status;", pay);
    if (pay == "success") {
      resultBtnTxt.value = "OK";
      resultInfo.value = "payResultSuccessInfo";
      resultImg.value = getImageUrlByNewURL("systemicon/notice_success.png");
      resultVisible.value = true;
      userstore.getUserInfo().then((res) => {
        console.log("充值成功,更新用户账户;", res);
      });
    } else if (pay == "fail") {
      eventEmitter.emit("api:no_enough", {pay});
    }
  });

  //重置对战tabkey=1
  eventEmitter.on("reset:battleTabKey", () => {
    console.log("重置对战tabkey=1");
    userstore.battleKey = "1";
  });
  // console.log("eventEmitter:", eventEmitter);

  //对战房间不存在,跳到对战大厅
  eventEmitter.on("api:toarena", toUrl);

  eventEmitter.on("nobind_SteamURL", () => {
    console.log("appnobind_SteamURL 监听绑定steam交易链接");
    router.push({
      path: "user",
    });
  });

  eventEmitter.on("api:showRechargeRebateModal", (val) => {
    console.log("showRechargeRebateModal", val);
    rechargeRebateVisible.value = true;
    rebate.value = val;
  });

  // 冻结皮肤弹框
  eventEmitter.on("api:freezeSkin", (val) => {
    console.log("api:freezeSkin", val);
    if (val === 'close') {
      globalCompName.value.delete('freezeSkinsModal')
      falg.value = false
    } else {
      globalCompName.value.add('freezeSkinsModal')
      globalModalData.value = val

    }
  })

  //监听nowpayment订单状态
  // eventEmitter.on("api:bean_detail", (data) => {
  //   //10分钟内,每个10s 发送websocket查询订单状态
  //   //超出10分钟,关闭定时器,不在查询
  //   //若10分钟内,收到订单状态变化,提示用户,更新账户余额,关闭订单监听
  //   console.log("nowpayment订单状态", data);
  //   // startOrderListening(data);
  // });

  //GA4监听
  eventEmitter.on("ga4:purchase", ga4.purchase);
}

onMounted(() => {
  console.log("proxy.$socket;", proxy.$socket);
  //首次访问清掉sitestore.openList
  siteStore.openList = [];

  initListenSocket();
  initCusEvent();
  console.log("proxy.$socket;", proxy.$socket);
  // console.log('初始网络状态;',navigator.onLine);
  // window.addEventListener("online", updateCount); // 监听网络恢复事件
  // window.addEventListener("offline", closeWebSocket); // 监听网络恢复事件
});
onMounted(async () => {
  await deviceStore.fetchDeviceInfo();
  console.log('设备类型:', deviceStore.deviceType);
  console.log('IP地址:', deviceStore.ip);
});
onUnmounted(() => {
  console.log("csgo页面销毁完毕");
  window.removeEventListener("online", updateCount); // 移除监听避免内存泄漏
  window.addEventListener("offline", closeWebSocket); // 监听网络恢复事件
  proxy.$EventBus.off("upd");
  document.removeEventListener("visibilitychange", (e) => {
    if (document.visibilityState === "hidden") {
      console.log("移除 hidden");
      handleFn();
    }
  });
  window.removeEventListener("beforeunload", (e) => handleFn());
  //移除websocket监听
});

const teststore = $store("test");
// console.log('tstore;',teststore);
// autoAuth();

// console.log('ts:',teststore.someState);
const {someState} = toRefs(teststore);
const {count} = toRefs(userstore);

//更新userstore.count 重新加载页面
function updateCount() {
  console.log("online事件");
  console.log("proxy.$socket;", proxy.$socket);
  console.log("++", userstore.count);
  userstore.count++;
  initListenSocket();
  initCusEvent();
  console.log("proxy.$socket;", proxy.$socket);
}

//处理登录弹框
function showLogin() {
  console.log("showLogin");
  //弹登录框
  console.log("弹登录框");
  //未登录显示登录框
  loginModal(
      {visible: true, title: $t("loginLarge"), contentType: "def"},
      (callnack) => {
        // console.log('未登录 弹登录框');
        callnack();
      }
  );
}

//处理余额是否足够游戏
function handleIsEnough(data) {
  console.log("handleIsEnough", data);
  const isBalance = isBalanceEnough(userstore, proxy, data.price);
  if(isBalance){//余额足够
    userstore.noEnough = false
  }else{
    if(userstore.userInfo.gem>=data.price){//宝石足够
      userstore.noEnough = false
    }else{
      userstore.noEnough = true//余额和宝石都不满足,弹充值框
    }
  }
  console.log("是否可以支付,", userstore.noEnough);
  if (userstore.noEnough) {
    eventEmitter.emit("api:no_enough");
  }
}

//处理充值弹框
function showRecharge(data) {
  console.log("showRecharge", data);
  proxy.$socket.Send("z");
  // return
  //如果未登录,则直接弹登录框,否则弹充值框
  if (!userstore.isToken) {
    showLogin();
  } else {
    //弹充值框
    console.log("弹充值框");
    rechargeModal({
      visible: true,
      // title: "hello",
      // options: { title: "hello", content: "world" },
    })
        .then((res) => {
          console.log("充值成功", res);
          if (data.pay == "fail") {
            resultBtnTxt.value = "TRY AGAIN";
            resultInfo.value = "payResultFailInfo";
            resultImg.value = getImageUrlByNewURL("systemicon/notice_error.png");
            resultVisible.value = true;
          }
        })
        .catch(() => {
          console.log("取消充值");
        });
  }
}

const playInfoVisible = ref(false);
const playInfoData = ref({});

function showPlayInfo(data) {
  console.log("showPlayInfo", data);
  playInfoVisible.value = true;
  playInfoData.value = data;
}

const telegramLoginVisible = ref(false);
const showTeleVisible = ref(false);

function closeTelegramLogin() {
  console.log("closeTelegramLogin");
  telegramLoginVisible.value = false;
}

const rechargeRebateVisible = ref(false);
const rebate = ref({});

//充值结果弹框
const resultVisible = ref(false);

function closeResult() {
  // return;
  resultVisible.value = false;
}

const resultBtnTxt = ref("OK"); //TRY AGAIN
const resultInfo = ref("payResultSuccessInfo");
const resultImg = ref(getImageUrlByNewURL("systemicon/notice_success.png"));

//处理nowpayment订单监听
//存储定时器ID
const queryTimer = ref(null);
//存储超时定时器
const timeoutTimer = ref(null);
//订单状态监听标识
const isListening = ref(true);
//超出时间(超出则关闭订单监听)
const expirestime = 20 * 60 * 1000; //20分钟
const everytime = 10 * 1000; //每隔10s 发送websocket查询

//发送websocket查询订单
function sendOrderQuery(data) {
  //发送websocket消息查询充值订单状态
  proxy.$socket.Send(data);
  console.log("发送websocket查询订单");
  //模拟测试充值
  return;
  proxy.$socket.Send("z");
  return new Promise((resolve, reject) => {
    const result = Math.trunc(Math.random() * 10);
    const data = {
      code: 200,
      result: result,
      msgType: "bean_detail",
      message: "操作成功",
      data: {
        bean: "10.00",
        price: "10.00",
        code: "202304111136438675",
        status: 1,
        created_at: "2023-04-11 11:36:43",
      },
    };
    resolve(data);
  });
}

//启动监听器
function startOrderListening(data) {
  stopOrderListening(); //清除之前的订单监听,只保留最新订单监听,当有多个订单产生时

  isListening.value = true;
  //每10s发送websocket查询订单状态[每10s执行一次查询]
  queryTimer.value = setInterval(() => {
    //订单状态未更新,发送查询
    console.log("isListening:", isListening.value);
    if (isListening.value) {
      sendOrderQuery(data);
      //订单由于后端socket推送,主动查询订单删掉sendOrderQuery
      //模拟测试
      return;
      sendOrderQuery(data).then((res) => {
        console.error("res;", res);
        if (res.code == 200) {
          if (res.result > 2) {
            //订单充值成功
            //提示用户
            // proxy.$message.success("充值成功$" + res.data.bean);
            proxy.$notice("s", {
              desc: $t("payStatusInfo", {account: "$" + res.data.bean}),
            });

            //更新账户余额
            proxy.$EventBus.emit("upd", {
              type: "increment",
              val: res.data.bean,
              paytype: "pay",
            });

            //关闭订单查询
            stopOrderListening();
          }
        } else {
          //网络或系统错误
        }
      });
    }
  }, everytime);

  //10分钟后停止所有查询
  timeoutTimer.value = setTimeout(() => {
    stopOrderListening();
    console.log("订单监听已超时关闭");
  }, expirestime);
}

// const faceBookCode = ref(
//   "EAANfoWTltqYBO6ry1hu1ae7A1XSZBUBZB5oPckrQav9rzwDtFyFqC3fyyy1jpVNyTpH23BwEBKyE3Pw6s8EZALCzd8OXgTdhu6w128q13ZC8KbNF2A3CQEhZBZCTZAtVvGT5L1Y03JVilFDs3peoHXM1uNpEYGBl0dK1mACxQ23Ag6PlmQ55gfhJXZAJ4HBqtdHZALQZDZD"
// ); //发送ajax请求动态的去获取像素代码，并复制给这个faceBookCode
// const imgurl = ref("");

// onMounted(() => {
//   imgurl.value =
//     "https://www.skinroll.net/tr?invite_id=FB0001&id=" +
//     faceBookCode.value +
//     "&ev=PageView&noscript=1";
//   !(function (f, b, e, v, n, t, s) {
//     if (f.fbq) return;
//     n = f.fbq = function () {
//       n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
//     };
//     if (!f._fbq) f._fbq = n;
//     n.push = n;
//     n.loaded = !0;
//     n.version = "2.0";
//     n.queue = [];
//     t = b.createElement(e);
//     t.async = !0;
//     t.src = v;
//     s = b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t, s);
//   })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
//   fbq("init", faceBookCode.value);
//   fbq("track", "PageView");
//   // fbq('track', 'AddPaymentInfo');//添加支付信息
//   // fbq('track', 'AddToCart');//加入购物车
//   // fbq('track', 'InitiateCheckout');//发起结账
//   // fbq('track', 'Purchase',{value:0.00,currency:'USD'});//购物
//   // fbq('track', 'ViewContent');//查看内容
// });

//停止监听
function stopOrderListening() {
  console.log("关闭nowpayment订单监听");
  isListening.value = false;
  clearInterval(queryTimer.value);
  clearTimeout(timeoutTimer.value);
}

//页面销毁,清除所有订阅的监听
onBeforeUnmount(() => {
  eventEmitter.offAllEvents();
  globalCompName.value.clear()
  globalModalData.value = null
});

// ===== 新增：邮箱奖励弹框 =====
const emailRewardVisible = ref(false)
const emailRewardUrl = ref('')
const emailRewardVerifyCode = ref('')
const emailRewardCountdown = ref(0)
const emailRewardIsSend = ref(false)
const emailRewardTimer = ref(null)

const emailRewardIsDisableSend = computed(() => {
  return !emailRewardUrl.value
})

const emailRewardCodeTime = computed(() => {
  return (a) => (a ? a + 's' : emailRewardIsSend.value ? $t('sending') : '')
})

function showEmailReward() {
  console.log('弹出完善邮箱送宝箱弹框')
  emailRewardVisible.value = true
}

function closeEmailReward() {
  emailRewardVisible.value = false
  sessionStorage.setItem('emailRewardDismissed', 'true')
  resetEmailReward()
}

function resetEmailReward() {
  clearInterval(emailRewardTimer.value)
  emailRewardIsSend.value = false
  emailRewardCountdown.value = 0
  emailRewardUrl.value = ''
  emailRewardVerifyCode.value = ''
}

// 发送邮箱验证码
function sendEmailRewardVerify() {
  if (!emailRewardUrl.value) {
    return showNotice('f', { desc: $t('noInputAccount') })
  }
  if (emailRewardIsSend.value) return
  emailRewardIsSend.value = true

  $api.user
      .sendEmailVerify({ email: emailRewardUrl.value, is_use: 1 })
      .then((res) => {
        const resp = handleResponse(res)
        if (!resp) {
          emailRewardIsSend.value = false
          return
        }
        if (emailRewardCountdown.value === 0 && emailRewardIsSend.value) {
          emailRewardCountdown.value = 180
          emailRewardTimer.value = setInterval(() => {
            emailRewardCountdown.value--
            if (emailRewardCountdown.value < 1) {
              resetEmailReward()
            }
          }, 1000)
        }
        showNotice('s', { desc: res.message })
      })
      .catch(() => {
        emailRewardIsSend.value = false
        showNotice('f', { desc: $t('requireAccept') })
      })
}

// 提交绑定邮箱
function submitEmailReward() {
  if (!emailRewardUrl.value) {
    return showNotice('f', { desc: $t('noInputAccount') })
  }
  if (!emailRewardVerifyCode.value) {
    return showNotice('f', { desc: $t('noInputVerifyCode') })
  }
  $api.user
      .bindEmail({ email: emailRewardUrl.value, verify: emailRewardVerifyCode.value })
      .then((res) => {
        if (res.code === 200) {
          showNotice('s', { desc: $t('emailBindSuccess') })
          closeEmailReward()
          userstore.getUserInfo()
        } else {
          showNotice('f', { desc: res.message || $t('emailBindFailed') })
        }
      })
      .catch(() => {
        showNotice('f', { desc: $t('emailBindFailed') })
      })
}
//全局弹框组件(弹哪个组件,传递哪个组件名字)
const globalCompName = ref(new Set())
const globalModalData = ref(null)
provide('globalModalData', globalModalData)
</script>

<template>
  <!-- Facebook Pixel Code -->
  <!--  <noscript>-->
  <!--    <img height="1" width="1" :src="imgurl" />-->
  <!--  </noscript>-->
  <!-- End Facebook Pixel Code -->
  <sitemaintenance v-bind="mainData" v-if="ismaintenance"></sitemaintenance>
  <div v-else :key="userstore.count">
    <!-- {{'sp:'+ sp }} -->
    <!-- <a-spin :spinning="sp" :tip="sp"> -->
    <!-- 轮播图 -->
    <!-- <swiperg></swiperg> -->

    <!--存放全局弹框组件,只做容器不做其他处理-->
    <globalModal :compName="globalCompName" ref="globalModalRef"></globalModal>

    <div class="head">
      <swiper v-if="10"></swiper>
    </div>
    <div class="type-area">
      <navbar></navbar>
      <!-- 非首页,顶部需要有内边距 -->
      <router-view v-slot="{ Component }">
        <KeepAlive :include="cacheComponents">
          <component :is="Component"/>
        </KeepAlive>
      </router-view>

      <!-- <router-view v-slot="{ Component }">
      <keep-alive>
      <component :is="Component" />
      </keep-alive>
    </router-view> -->
    </div>
    <recharge></recharge>

    <!-- 运作方式弹框 -->
    <playInfo
        @close="playInfoVisible = false"
        :visible="playInfoVisible"
        :data="playInfoData"
    ></playInfo>

    <!-- 充值结果提示弹框 -->
    <myModal
        class="recharge-result-modal"
        :test="'test'"
        :visible="resultVisible"
        @close="closeResult($event)"
        :z-index="1001"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="tips">TIPS</div>
        <div class="content">
          <div class="info">
            <img :src="resultImg" alt=""/>
            <div class="infos">
              {{ $t(resultInfo) }}
            </div>
          </div>
          <a-button class="result-btn" @click="closeResult($event)"
          >{{ resultBtnTxt }}
          </a-button>
        </div>
      </template>
    </myModal>

    <!--    飞机登录弹框-->
    <myModal
        class="telegram-login-modal"
        :visible="telegramLoginVisible"
        @close="closeTelegramLogin($event)"
        :z-index="1001"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="tips">Telegram</div>
        <div class="content">
          <telegramAuth v-if="showTeleVisible" size="large"></telegramAuth>
        </div>
      </template>
    </myModal>

    <!--    充值返利侧边栏框-->
    <rechargeRebateSmall
        @close="() => (siteStore.rechargeRebateSmallVisible = false)"
        :visible="siteStore.rechargeRebateSmallVisible"
    ></rechargeRebateSmall>

    <!--    充值返利弹框-->
    <rechargeRebate
        @close="
        () => {
          rechargeRebateVisible = false;
        }
      "
        :visible="rechargeRebateVisible"
        :rebate="rebate"
    ></rechargeRebate>

    <!--  完善邮箱送宝箱弹框  -->
    <myModal class="email-reward-modal-new" :visible="emailRewardVisible" @close="closeEmailReward" :z-index="1002">
      <template #cuscloseIcon>
        <span></span>
      </template>
      <template #body>
        <div class="email-reward-container">
          <img src="@/assets/images/user/email_model.png" alt="" class="email-bg-img" />
          <div class="email-modal-close" @click="closeEmailReward">
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
              <path d="M1 1L13 13M13 1L1 13" stroke="#6b7fa0" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="email-form-overlay">
            <h2 class="email-main-title">{{ $t("Subscribedemail") }}</h2>
            <p class="email-sub-title">{{ $t("SubscribeemailReward") }}</p>
            <div class="email-input-group">
              <input
                  v-model="emailRewardUrl"
                  type="email"
                  :placeholder="$t('pleaseInputEmailAccount') || 'Enter your email'"
                  class="email-field"
              />
            </div>
            <div class="email-input-group email-code-group">
              <input
                  v-model="emailRewardVerifyCode"
                  type="text"
                  :placeholder="$t('verifCode') || 'Code sent'"
                  class="email-code-field"
                  @keyup.enter="submitEmailReward"
              />
              <button
                  class="email-send-btn"
                  :class="{ 'email-send-disabled': emailRewardIsSend || emailRewardIsDisableSend }"
                  :disabled="emailRewardIsSend || emailRewardIsDisableSend"
                  @click="sendEmailRewardVerify"
              >
                {{ emailRewardCodeTime(emailRewardCountdown) || $t("send") || "SEND" }}
              </button>
            </div>
            <button class="email-claim-btn" @click="submitEmailReward">
              {{ $t("claimBonus") || "CLAIM BONUS" }}
            </button>
          </div>
        </div>
      </template>
    </myModal>

    <!-- 底部版权-联系我们区域 -->
    <footerContainer/>
    <!-- </a-spin> -->
  </div>
</template>

<style lang="scss" scoped>
//版心未设置
.test {
  font-size: 0.2rem;
  height: 800px;
}

//充值结果弹框
.recharge-result-modal {
  :deep(.ant-modal) {
    width: 4.96rem !important;
    height: 2.9rem;
    top: 20%;
    background-color: #0e121e;

    .ant-modal-close-x {
      position: absolute;
      top: 0.14rem;
      right: 0.1rem;

      img {
        width: 0.16rem;
      }
    }

    .ant-modal-body {
      height: 2.9rem;
      @extend %flex-all-center;
      flex-direction: column;

      .tips {
        color: #ffffff;
        font-size: 0.24rem;
        font-weight: bold;
        margin-bottom: 0.5rem;
      }

      .content {
        width: 100%;
        @extend %flex-all-center;
        flex-direction: column;

        .info {
          @extend %flex-all-center;
          font-size: 0.17rem;
          font-weight: 400;
          color: #a3b2cf;

          .infos {
            width: max-content;
            max-width: 3.1rem;
          }

          img {
            width: 0.4rem;
            margin-right: 0.1rem;
          }
        }

        .result-btn {
          &:hover {
            background-color: #eb336b;
          }

          margin-top: 0.31rem;
          width: 1.7rem;
          height: 0.46rem;
          border-radius: 0.23rem;
          background-color: $active-color;
          font-size: 0.2rem;
          font-weight: bold;
        }
      }
    }
  }
}

//飞机登录弹框
.telegram-login-modal {
  :deep(.ant-modal) {
    width: 360px !important;
    height: 190px;
    top: 20%;
    background-color: #0e121e;

    .ant-modal-close-x {
      position: absolute;
      top: 14px;
      right: 10px;

      img {
        width: 16px;
      }
    }

    .ant-modal-body {
      height: 190px;
      @extend %flex-all-center;
      flex-direction: column;

      .tips {
        color: #ffffff;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 50px;
      }

      .content {
        width: 100%;
        @extend %flex-all-center;
        flex-direction: column;
      }
    }
  }
}

// 完善邮箱送宝箱弹框
.email-reward-modal-new {
  :deep(.ant-modal) {
    width: 440px !important;
    overflow: visible;

    .ant-modal-content {
      background: transparent;
      border: none;
      box-shadow: none;
      overflow: visible;
      padding: 0;
    }

    .ant-modal-close {
      display: none;
    }

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      padding: 0;
      overflow: visible;
    }
  }
}

.email-reward-container {
  position: relative;
  width: 100%;
}

.email-bg-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 16px;
}

.email-modal-close {
  position: absolute;
  top: 20%;
  right: 14px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.55);

    svg path {
      stroke: #fff;
    }
  }
}

.email-form-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 5;
}

.email-main-title {
  font-size: 20px;
  font-weight: 800;
  color: #e8edf5;
  text-align: center;
  margin: 0 0 4px;
  letter-spacing: -0.2px;
  line-height: 1.3;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
}

.email-sub-title {
  font-size: 13px;
  font-weight: 400;
  color: #7b8fad;
  text-align: center;
  margin: 0 0 22px;
  line-height: 1.4;
}

.email-input-group {
  width: 100%;
  margin-bottom: 12px;
  position: relative;
}

.email-field,
.email-code-field {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  border: 1.5px solid rgba(100, 150, 220, 0.2);
  background: rgba(10, 20, 40, 0.6);
  backdrop-filter: blur(6px);
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  color: #e0e6f0;
  outline: none;
  transition: all 0.25s;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(140, 160, 190, 0.45);
  }

  &:focus {
    border-color: rgba(59, 140, 255, 0.5);
    background: rgba(15, 30, 60, 0.7);
    box-shadow: 0 0 0 3px rgba(59, 140, 255, 0.08);
  }
}

.email-code-group {
  position: relative;

  .email-code-field {
    padding-right: 105px;
  }

  .email-send-btn {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    height: 38px;
    min-width: 85px;
    padding: 0 18px;
    border-radius: 19px;
    border: 1.5px solid rgba(59, 140, 255, 0.5);
    background: transparent;
    color: #5ba3ff;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.25s;

    &:hover:not(:disabled) {
      background: rgba(59, 140, 255, 0.1);
      border-color: rgba(59, 140, 255, 0.7);
    }

    &:active:not(:disabled) {
      transform: translateY(-50%) scale(0.97);
    }
  }

  .email-send-disabled {
    border-color: rgba(100, 120, 150, 0.15);
    color: #3d4a5e;
    cursor: not-allowed;
  }
}

.email-claim-btn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  border: 1.5px solid rgba(59, 140, 255, 0.3);
  background: linear-gradient(135deg, rgba(20, 55, 130, 0.3), rgba(25, 70, 160, 0.2));
  color: #b8d4ff;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.5px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 4px;

  &:hover {
    border-color: rgba(59, 140, 255, 0.55);
    color: #dce9ff;
    box-shadow: 0 0 18px rgba(59, 140, 255, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
}
</style>